import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class MembershipReportQueryCriteriaClass extends BaseCriteriaModel {
    guids?: Optional<string[]> = Optional.empty();
    entity_hdr_guids?: Optional<string[]> = Optional.empty();
    guid?: Optional<string> = Optional.empty();
    card_no?: Optional<string> = Optional.empty();
    is_card_no_encoded?: Optional<string> = Optional.empty();
    member_id?: Optional<string> = Optional.empty();
    id_no?: Optional<string> = Optional.empty();
    id_type?: Optional<string> = Optional.empty();
    phone?: Optional<string> = Optional.empty();
    is_phone_encoded?: Optional<string> = Optional.empty();
    email?: Optional<string> = Optional.empty();
    ref_1?: Optional<string> = Optional.empty();
    ref_2?: Optional<string> = Optional.empty();
    ref_3?: Optional<string> = Optional.empty();
    ref_4?: Optional<string> = Optional.empty();
    ref_5?: Optional<string> = Optional.empty();
    login_subject_guid?: Optional<string> = Optional.empty();
    start_date?: Optional<string> = Optional.empty();
    end_date?: Optional<string> = Optional.empty();
    entity_hdr_guid?: Optional<string> = Optional.empty();
    company_guid?: Optional<string> = Optional.empty();
    branch_guid?: Optional<string> = Optional.empty();
    created_from?: Optional<string> = Optional.empty();
    created_to?: Optional<string> = Optional.empty();
    contact_key_guid?: Optional<string> = Optional.empty();
    name?: Optional<string> = Optional.empty();
    client_key?: Optional<string> = Optional.empty();
    client_source?: Optional<string> = Optional.empty();
    membership_class_guid?: Optional<string> = Optional.empty();
    membership_class_code?: Optional<string> = Optional.empty();
    gender?: Optional<string> = Optional.empty();
    dob?: Optional<string> = Optional.empty();
    country_code?: Optional<string> = Optional.empty();
    hdr_created_date_to?: Optional<string> = Optional.empty();
    hdr_created_date_on?: Optional<string> = Optional.empty();
    hdr_created_date_from?: Optional<string> = Optional.empty();
    hdr_updated_date_to?: Optional<string> = Optional.empty();
    hdr_updated_date_from?: Optional<string> = Optional.empty();
    hdr_updated_date_on?: Optional<string> = Optional.empty();
    status_01?: Optional<string> = Optional.empty();
    card_no_like?: Optional<string> = Optional.empty();
    name_like?: Optional<string> = Optional.empty();
    id_no_like?: Optional<string> = Optional.empty();
    id_type_like?: Optional<string> = Optional.empty();
    phone_like?: Optional<string> = Optional.empty();
    email_like?: Optional<string> = Optional.empty();
    member_id_like?: Optional<string> = Optional.empty();
    end_date_from?: Optional<string> = Optional.empty();
    end_date_to?: Optional<string> = Optional.empty();
    dob_from?: Optional<string> = Optional.empty();
    dob_to?: Optional<string> = Optional.empty();
    start_date_from?: Optional<string> = Optional.empty();
    start_date_to?: Optional<string> = Optional.empty();
    card_type?: Optional<string> = Optional.empty();
    card_type_guids?: Optional<string[]> = Optional.empty();
    client_customer_code?: Optional<string> = Optional.empty();
    nationality?: Optional<string> = Optional.empty();
    occupation?: Optional<string> = Optional.empty();
    marital_status?: Optional<string> = Optional.empty();
    card_end_date_from?: Optional<string> = Optional.empty();
    card_end_date_to?: Optional<string> = Optional.empty();
    card_start_date_from?: Optional<string> = Optional.empty();
    card_start_date_to?: Optional<string> = Optional.empty();
    xtn_icno?: Optional<string> = Optional.empty();
    xtn_hand_phone?: Optional<string> = Optional.empty();
    xtn_home_phone?: Optional<string> = Optional.empty();
    xtn_office_phone?: Optional<string> = Optional.empty();
    xtn_email?: Optional<string> = Optional.empty();
    is_lifetime?: Optional<boolean> = Optional.empty();
    param_code?: Optional<string> = Optional.empty();
    param_name?: Optional<string> = Optional.empty();
    value_string?: Optional<string> = Optional.empty();
    value_numeric?: Optional<string> = Optional.empty();
    ext_created_date_to?: Optional<string> = Optional.empty();
    ext_created_date_from?: Optional<string> = Optional.empty();
    ext_updated_date_to?: Optional<string> = Optional.empty();
    ext_updated_date_from?: Optional<string> = Optional.empty();
    client_value?: Optional<string> = Optional.empty();
}